<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">告警信息</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <div class>
        <SForm
          ref="formref"
          :fields="formfields"
          :data-form="rowdata"
          label-width="120px"
          :is-show-btn="false"
          :inline="false"
        />
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">电站信息</span>
      </div>
      <el-form ref="firstForm" :model="firstForm" label-position="right" label-width="120px" style="width: 400px; margin-top: 20px;">
        <el-form-item label="选择电站" prop="stationIDs">
          <STree v-model="firstForm.stationIDs" :data="datatree" :is-show-filter="false" style="width:400px;" />
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { treeDisabled } from '@/utils/tool'
import { HOST, EV_HOST } from '@/utils/host'
const token = window.localStorage.getItem('token')
export default {
  name: 'Gaojingshezhixiangqingxiangqing',
  components: {},
  data() {
    return {
      datatree: [],
      rowdata: {},
      formfields: [
        {
          label: '告警通知组名称',
          type: 'div',
          prop: 'groupName'
        },
        {
          label: '通知号码',
          type: 'div',
          prop: 'phoneList'
        }
      ],
      firstForm: {
        stationIDs: []
      },
      formbefore: record => {
        console.log(record)
        return record
      },
      id: ''
    }
  },
  computed: {
    headers() {
      // console.log(token);
      return {
        token: token
      }
    }

  },
  mounted() {
    this.getTree()
    this.getDataDetail()
  },
  beforeCreate() {

  }, // 生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    cancel() {
      this.$router.go(-1)
    },

    getDataDetail() {
      const data = {
        id: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/alarm/alarmNoticeGroup/getEditData',
        data: data,
        method: 'get',
        callback: resp => {
          console.log('tree', resp)
          this.rowdata = resp
          this.firstForm.stationIDs = resp.stationIDs.split(',')
        }
      })
    },

    getTree() {
      this.$store.dispatch('form/handle', {
        url: '/alarm/alarmSet/connectorTree',
        method: 'get',
        callback: resp => {
          console.log('tree', resp)
          this.datatree = treeDisabled(resp, true)
        }
      })
    }

  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

  <style lang="less" src="" scoped>
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  </style>



// WEBPACK FOOTER //
// src/views/alarmManagement/groupManagementDetail.vue